import content from "@/content/siteContent";

export default function Marquee() {
  const items = [...content.marquee, ...content.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-plz-line/60 bg-plz-navy/50 py-5"
    >
      <div className="marquee-track flex w-max items-center">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-heading text-lg font-semibold tracking-wide text-plz-slate">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-plz-orange/80" />
          </span>
        ))}
      </div>
    </div>
  );
}
